export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

export const slickCarousel = () => {
  const slick_slider = $(".slickCarousel");

  function callSlickSlider(numberOfSlides) {
    slick_slider.slick({
      swipe: true,
      autoplay: true,
      dots: true,
      infinite: false,
      appendDots: $(".bar"),
      prevArrow: $(".slide-left"),
      nextArrow: $(".slide-right"),
      slidesToShow: numberOfSlides,
      slidesToScroll: 1,
      mobileFirst: true,
      rows: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  if ($(window).width() < 480) {
    callSlickSlider(1);
  } else if ($(window).width() < 770 && $(window).width() > 480) {
    callSlickSlider(3);
  } else {
    callSlickSlider(4);
  }

  $(window).on("resize", function () {
    slick_slider.slick("resize");
  });
};



// WEBPACK FOOTER //
// ./scripts/sections/slides.js